import React from 'react';
import '../applications-css/Application.css'
import "../applications-css/Help.css";

class Help extends React.Component {
  checkersHelp() {
    return(
      <span data-testid="checkers-help" >
      <hr></hr>
      <p>Checkers:</p>
      <p>- Click your pieces to show where you can move them.</p>
      <p>- Click the spot you would like to move the piece to.</p>
      <p>- You can get a king by moving to your opponent's home row.</p>
      <p>- You win if you take all your opponent's pieces.</p>
      </span>
    )
  }

  minesweeperHelp() {
    return(
      <span data-testid="minesweeper-help" >
      <hr></hr>
      <p>Minesweeper:</p>
      <p>- Click squares to try to reveal squares without mines.</p>
      <p>- To flag squares as potential mines, click the flag in the upper right, and click the square(s) to mark.</p>
      <p>- To return to the regular clicking mode, click the flag in the upper right again.</p>
      <p>- You win when all non-mine squares are revealed.</p>
      </span>
    )
  }

  othelloHelp() {
    return(
      <span data-testid="othello-help" >
      <hr></hr>
      <p>Othello:</p>
      <p>- Click squares to place your piece and flip your opponent's pieces.</p>
      <p>- If you can't make a move, click the Pass button in the upper right.</p>
      <p>- Once all spaces are taken, or once both players Pass consecutively, the winner is calculated.</p>
      <p>- You win if you have more pieces of your color on the board.</p>
      </span>
    )
  }

  render() {
    return(
      <div id="helpWrapper" className="outsideWrapper">
        <center data-testid="header"><h4> Game Instructions: </h4></center>
        {this.checkersHelp()}
        {this.minesweeperHelp()}
        {this.othelloHelp()}
      </div>
    )
  }
}

export default Help;
